(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbGridPanel', lbGridPanelDirective);

    function lbGridPanelDirective(Path, $location, $window) {
        return {
            restrict: 'EA',
            scope: {
                panel:"="
            },
            templateUrl: 'common/libraries/layoutBuilder/panels/grid',
            compile:compileFunc
        };

        function compileFunc(){
            return {
                post: function postLink(scope, elem) {
                    elem.addClass('lb-grid-wrapper');
                    scope.resizeGrid = function() {
                        var _grid =elem.find('.k-grid');
                        if (_grid.length > 0) {
                            _grid.find(".k-grid-content").css('height','auto');
                            _grid.data('kendoGrid').resize();
                        }
                    };

                    var w = angular.element($window);
                    w.bind('resize', function () {
                        scope.resizeGrid();
                    });

                    scope.$on('$destroy', function() {
                        w.unbind('resize');
                    });
                    scope.resizeGrid();
                }
            };
        }
    }
})();